import React from 'react';
import moment from 'moment-timezone';

export default class ClockForTimezone extends React.Component {
	static defaultProps = {
		format: 'h:mm A'
	};
	componentWillMount() {
		this.interval = setInterval(() => {
			this.forceUpdate();
		}, 5000);
	}
	componentWillUnmount(){
		clearInterval(this.interval);
	}

    render() {
    	return (
    		<span>{moment.tz(this.props.timezone).format(this.props.format)}</span>
    	);        
    }
}


// WEBPACK FOOTER //
// ./app/components/ClockForTimezone.js